module.exports = __webpack_public_path__ + "static/media/4.52db3582.png";